import { useEffect } from "react";

import rescuePositionIcon from "../assets/rescue-position-icon.png";

type Props = {
  __map__?: any;
  __amapui__?: any;
  rescuePosition?: {
    lng?: any;
    lat?: any;
  };
};
export default function AmapMarker(props: Props) {
  const { __map__, rescuePosition } = props;

  useEffect(() => {
    __map__.clearMap();

    let markerRescue;
    if (rescuePosition && rescuePosition.lng && rescuePosition.lat) {
      markerRescue = new window.AMap.Marker({
        position: new window.AMap.LngLat(
          rescuePosition.lng,
          rescuePosition.lat
        ),
        title: "救援地点",
        icon: new window.AMap.Icon({
          size: new AMap.Size(73, 73),
          imageSize: new AMap.Size(73, 73),
          image: rescuePositionIcon,
        }),
      });

      __map__.add(markerRescue);
    }

    if (markerRescue) {
      let markerRescueLngLat = markerRescue.getPosition();
      __map__.setCenter(markerRescueLngLat);
      __map__.setZoom(15);
    }
  }, [rescuePosition, __map__]);

  return null;
};
